import ReactPDF, { View } from "@react-pdf/renderer";
import { FC } from "react";
import { styles } from "./styles";

export const TableColumn: FC<ReactPDF.ViewProps & {
    width?: string;
}> = (props) => {
    const { children, width, ...rest } = props;
    return <View
        {...rest}
        style={{
            ...styles.tableCol,
            ...(rest.style ?? {}),
            // width: width ?? "50%",
        }}>
        {children}
    </View>
}